<div class="p-9">
  <div class="flex items-center justify-between">
    <div class="flex flex-row items-center gap-2">
      <ion-icon class="alert-icon" icon="assets/icon/alert-red-circle.svg"></ion-icon>
      <span class="alert-text barlow">¡ATENCIÓN!</span>
    </div>
    <ion-icon
      class="close-icon cursor-pointer"
      icon="assets/icon/cross.svg"
      (click)="modalController.dismiss()"
    ></ion-icon>
  </div>
  <hr class="my-7" />
  <div class="flex flex-col gap-5">
    <p class="text1 barlow">Has seleccionado plastificar tus documentos. Por favor, lee este texto atentamente. 🙏</p>
    <div class="warning-box barlow">Tus documentos se imprimirán en papel de 80gr.</div>
    <p class="text2 barlow">
      Al plastificar un documento, el grosor, la dureza y la flexibilidad dependen de las micras del plastificado, no
      del gramaje del papel. Por eso, imprimimos tus documentos en papel de 80gr y tú eliges el grosor del plastificado
      en el configurador 🤗.
    </p>
  </div>
  <hr class="my-7" />
  <div class="flex flex-row gap-1">
    <ion-button class="flex-1" color="medium-light" (click)="modalController.dismiss()">Cancelar</ion-button>
    <ion-button class="flex-1" (click)="modalController.dismiss(true)">Seguir y configurar plastificado</ion-button>
  </div>
</div>
